<template>
  <div>
    <b-sidebar
      :id="id"
      :right="right"
      :shadow="shadow"
      :backdrop="backdrop"
      :width="width"
      :lazy="lazy"
      :no-header="true"
      v-model="model"
      @hidden="close"
      bg-variant="white"
    >
      <template #default="{ hide }">
        <div class="shadow-sm">
          <div class="p-3">
            <slot v-if="noHeader" name="header" :close="hide"></slot>
            <div
              v-else
              class="d-flex justify-content-between align-items-center"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div
                  class="custom-sidebar-header-icon mr-1 rounded-circle shadow-sm text-center"
                >
                  <span class="text-white" :class="titleIcon"></span>
                </div>
                <span>
                  {{ title }}
                </span>
              </div>
              <div>
                <i
                  class="fal fa-circle-xmark pointer text-danger"
                  @click="hide"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div class="p-4">
          <slot :close="hide"></slot>
        </div>
      </template>
      <template #footer="{ hide }">
        <div v-if="!noFooter" class="shadow-sm-top">
          <div class="p-3">
            <slot name="footer" :close="hide"></slot>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: 'CustomSidebar',
  components: {},
  props: {
    id: {
      type: String,
      default: () => `custom-sidebar-${Math.trunc(Math.random() * 10000)}`,
    },
    value: {
      type: Boolean,
      default: () => true,
    },
    title: {
      type: String,
      default: () => '',
    },
    titleIcon: {
      type: String,
      default: () => '',
    },
    titleIconColor: {
      type: String,
      default: () => 'white',
    },
    titleIconBgColor: {
      type: String,
      default: () => 'bg-orange',
    },
    right: {
      type: Boolean,
      default: () => true,
    },
    shadow: {
      type: Boolean,
      default: () => true,
    },
    backdrop: {
      type: Boolean,
      default: () => true,
    },
    lazy: {
      type: Boolean,
      default: () => false,
    },
    width: {
      type: String,
      default: () => '580px',
    },
    noHeader: {
      type: Boolean,
      default: () => false,
    },
    noFooter: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.custom-sidebar-header-icon {
  width: 25px;
  height: 25px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border: solid 1px white;
}
.custom-sidebar-header-icon + span {
  font-weight: 600;
}
.pointer {
  cursor: pointer;
}
.shadow-sm-top {
  box-shadow: 0.125rem 0 0.35rem rgba(0, 0, 0, 0.3) !important;
}

::v-deep .b-sidebar {
  height: 100%;
}
</style>
